import { ArtifactoryDao } from '../artifactory_dao';

const { BASE_URL, API_VERSION } = window.jf

export class ProjectAdminDao extends ArtifactoryDao {

    constructor($resource, RESOURCE, artifactoryNotificationsInterceptor) {
        super($resource, RESOURCE, artifactoryNotificationsInterceptor);

        this.setUrl(`${BASE_URL}${API_VERSION}${RESOURCE.PROJECT_ADMIN}/:entityType/:entityName/admin`);

        this.setCustomActions({
            'isProjectAdmin': {
                method: 'GET',
                notifications: true
            },
            'setEntityAsProjectAdmin': {
                method: 'POST',
                params:{ entityType: '@entityType', entityName: '@entityName'},
                notifications: true
            },
            'unsetEntityAsProjectAdmin': {
                method: 'DELETE',
                params:{ entityType: '@entityType', entityName: '@entityName'},
                notifications: true
            }
        });
    }
}



// WEBPACK FOOTER //
// ./data/dao/project_admin_dao.js